<template>
  <div class="convert-contents">
    <div class="btn_container">
      <div><i-button type="primary" size="small" icon="ios-search" @click="onClickSearch">検索</i-button></div>
      <div style="margin-top: 4px;">
        <i-button
          type="primary"
          size="small"
          to="https://3nosuke.jp/manual/sale_portalsite_timeschedule.html"
          target="_blank"
        >
          ポータルサイト送信時間一覧
        </i-button>
      </div>
    </div>
    <ShopTab />
    <transition-group>
      <div class="list-item" :key="`transitionGroup${1}`">
        <div>
          <i-tab>
            <i-tab-panel label="サマリー" name="summary">
              <div>
                <div class="search_container">
                  状況検索：
                  <i-radio-group
                    type="button"
                    size="small"
                    v-model="search.summary_type"
                    @on-change="onChangeSearchType"
                  >
                    <i-radio label="or">OR</i-radio>
                    <i-radio label="and">AND</i-radio>
                  </i-radio-group>
                </div>
                <SummaryTable />
              </div>
            </i-tab-panel>
            <i-tab-panel label="送信結果" name="convert">
              <ResultTable />
            </i-tab-panel>
          </i-tab>
        </div>
      </div>
    </transition-group>
    <SearchText />
  </div>
</template>

<script>
import { Button, Tabs, TabPane, RadioGroup, Radio } from 'view-design'
import ShopTab from './ShopTab'
import SummaryTable from './Summary'
import ResultTable from './Result'
import SearchText from './SearchText'
import SearchProperty from '@/mixins/search'
export default {
  mixins: [SearchProperty],
  components: {
    'i-button': Button,
    'i-tab': Tabs,
    'i-tab-panel': TabPane,
    'i-radio-group': RadioGroup,
    'i-radio': Radio,
    ShopTab,
    SummaryTable,
    ResultTable,
    SearchText,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    selectSummaryText: {
      get() {
        return this.$store.getters['ConvertSummary/getSelectSummaryText']
      },
      set(val) {
        this.$store.commit('ConvertSummary/setSelectSummaryText', val)
      },
    },
    shopId() {
      return this.$store.getters['ConvertSummary/getShopId']
    },
  },
  methods: {
    // 検索ボタン クリック処理
    onClickSearch() {
      this.searchProperty(this.type)
    },
    // 検索タイプが変更された時の処理
    onChangeSearchType(val) {
      // サマリー検索テキストを変更する
      let searchText = this.selectSummaryText[this.shopId]
      if (searchText) {
        searchText = val === 'or' ? searchText.replace(/かつ/g, 'もしくは') : searchText.replace(/もしくは/g, 'かつ')
        this.$set(this.selectSummaryText, this.shopId, searchText)
      }
    },
  },
}
</script>

<style lang="scss">
.convert-contents {
  .btn_container {
    text-align: right;
  }
  .search_container {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .ivu-tabs-nav-container {
    font-size: 14px;
  }
}
</style>
